export const COMMUNITY_REFERRAL_EARNING_RUPEES = 20;
export const COUNSELLING_COMPLETION_EARNING_RUPEES = 500;
